import { faEdit } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import axios from 'axios'
import { MDBDataTable, MDBTable, MDBTableBody, MDBTableHead } from 'mdbreact'
import React from 'react'
import { useState } from 'react'
import { useEffect } from 'react'

const VerInventario = ({ baseUrl, productoSelecccionado }) => {
    const [inventario, setInventario] = useState([])

    useEffect(() => {

        const obtenerDatos = async () => {
            try {
                const { data } = await axios(baseUrl);
                setInventario(data)
            } catch (error) {
                console.log(error)
            }
        }
        obtenerDatos()
    }, [])



    return (
        <>
            <MDBTable hover>
                <MDBTableHead>
                    <tr>
                        <th>Id</th>
                        <th>Fecha</th>
                        <th>Producto</th>
                        <th>Atributo</th>
                        <th>Opciones</th>
                        <th>Usuario</th>
                        <th>Cantidad</th>
                        <th></th>
                    </tr>
                </MDBTableHead>
                <MDBTableBody>

                    {inventario.map((item, index) => {
                        return (
                            <tr key={index}>
                                <td>{item.id}</td>
                                <td>{item.fecha}</td>
                                <td>{item.producto}</td>
                                <td>{item.atributo}</td>
                                <td>{item.opciones}</td>
                                <td>{item.usuario}</td>
                                <td className='textVerde'>+{item.cantidad} und</td>
                                <td className="tabla_funciones">
                                    <div className="col text-center">
                                        <button
                                            onClick={() => productoSelecccionado(item)}
                                            className="btn boton_estandar_blanco"
                                        ><FontAwesomeIcon icon={faEdit} size="lg" />
                                        </button>
                                    </div>

                                </td>
                            </tr>
                        )
                    })}

                </MDBTableBody>
            </MDBTable>
        </>

    )
}

export default VerInventario